export const formHelperLabels = {
  mandatory: "*",
  gstinWarning: "In-active Gstin"
};
export enum GstinStatusField {
  isActive = "isActive"
}
